(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4373],{

/***/ 7992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const React = __webpack_require__(67294);

function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(ChevronRightIcon);
module.exports = ForwardRef;

/***/ }),

/***/ 54234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ejercicios",
      function () {
        return __webpack_require__(55696);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 42008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ SEO_DEFAULT; }
/* harmony export */ });
const SEO_DEFAULT = {
    id: 0,
    title: "Codealo",
    description: "La mejor comunidad de programadores en Latino Am\xe9rica",
    robots: "noindex",
    canonicalUrl: "https://codealo.dev",
    image: undefined,
    socials: []
};


/***/ }),

/***/ 55696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ejercicios; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(60699);
// EXTERNAL MODULE: ./src/components/atoms/Container/index.tsx
var Container = __webpack_require__(58605);
// EXTERNAL MODULE: ./src/components/molecules/PageHeading/index.tsx
var PageHeading = __webpack_require__(64798);
// EXTERNAL MODULE: ./src/components/molecules/Pagination/index.tsx
var Pagination = __webpack_require__(71742);
// EXTERNAL MODULE: ./src/components/atoms/Tag/index.tsx
var Tag = __webpack_require__(13476);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(7992);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/CalendarIcon.js
var CalendarIcon = __webpack_require__(79826);
// EXTERNAL MODULE: ./node_modules/luxon/src/luxon.js + 23 modules
var luxon = __webpack_require__(30120);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/molecules/Exercises/ExerciseListItem.tsx







const ExerciseListItem = (param)=>{
    let { exercise  } = param;
    var ref, ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/ejercicios/".concat(exercise.attributes.slug),
            className: "block hover:bg-gray-50",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center px-4 py-4 sm:px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "truncate",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "truncate font-medium text-primary",
                                            children: exercise.attributes.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "truncate text-sm text-gray-500",
                                            children: exercise.attributes.hook
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-2 flex gap-2",
                                        children: [
                                            (ref = exercise.attributes.techStack) === null || ref === void 0 ? void 0 : ref.data.map((tech)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                                    type: tech.attributes.name,
                                                    color: tech.attributes.color
                                                }, tech.attributes.name)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                                type: exercise.attributes.level,
                                                color: exercise.attributes.level === "Principiante" ? "green" : "yellow"
                                            }, exercise.attributes.level)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "mt-2 flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon, {
                                                className: "mr-1.5 h-4 w-4 flex-shrink-0 text-gray-400",
                                                "aria-hidden": "true"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-sm text-gray-400",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                                                    dateTime: exercise.attributes.publishedAt,
                                                    children: luxon/* DateTime.fromISO */.ou.fromISO(exercise.attributes.publishedAt).setLocale("es").toFormat("dd LLLL yyyy")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-4 flex-shrink-0 sm:ml-5 sm:mt-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex -space-x-1 overflow-hidden",
                                    children: [
                                        (ref1 = exercise.attributes.users) === null || ref1 === void 0 ? void 0 : ref1.map((param)=>{
                                            let { user  } = param;
                                            var ref, ref1;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("img", {
                                                className: "inline-block h-6 w-6 rounded-full ring-2 ring-white",
                                                src: ((ref = user.profilePhoto) === null || ref === void 0 ? void 0 : ref.url) ? "https://codealo-v2-dev-cms.onrender.com/" + ((ref1 = user.profilePhoto) === null || ref1 === void 0 ? void 0 : ref1.url) : "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                                                alt: user.username
                                            }, user.id);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "pl-3 text-gray-500",
                                            children: exercise.attributes.submissions > 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "+",
                                                    exercise.attributes.submissions - 3,
                                                    " ",
                                                    exercise.attributes.submissions - 3 === 1 ? "persona" : "personas"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "ml-5 flex-shrink-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon, {
                            className: "h-5 w-5 text-gray-400",
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Exercises_ExerciseListItem = (ExerciseListItem);

// EXTERNAL MODULE: ./src/contexts/PaginationContext.tsx + 1 modules
var PaginationContext = __webpack_require__(83435);
;// CONCATENATED MODULE: ./src/components/organisms/StackedList/index.tsx




const StackedList = ()=>{
    const { data , isSuccess  } = (0,PaginationContext/* usePagination */.h)();
    if (!isSuccess) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: "Loading"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "overflow-hidden bg-white shadow sm:rounded-md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            role: "list",
            className: "divide-y divide-gray-200",
            children: data.map((exercise)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Exercises_ExerciseListItem, {
                    exercise: exercise
                }, exercise.id))
        })
    });
};
/* harmony default export */ var organisms_StackedList = (StackedList);

// EXTERNAL MODULE: ./src/services/DefaultService.ts + 1 modules
var DefaultService = __webpack_require__(82829);
;// CONCATENATED MODULE: ./src/components/views/Exercises/Exercises.tsx








const Exercises = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        className: "mb-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaginationContext/* PaginationProvider */.b, {
            queryKey: "getExercises",
            queryFunction: DefaultService/* getExercises */.VI,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeading/* default */.Z, {
                    title: "Ejercicios de Programaci\xf3n",
                    description: "Pon a prueba tus conocimientos con estos ejercicios de programaci\xf3n"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(organisms_StackedList, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {})
                })
            ]
        })
    });
};
/* harmony default export */ var Exercises_Exercises = (Exercises);

// EXTERNAL MODULE: ./src/constants/SeoDefault.ts
var SeoDefault = __webpack_require__(42008);
;// CONCATENATED MODULE: ./src/pages/ejercicios/index.tsx




const Index = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultLayout/* default */.Z, {
        seo: SeoDefault/* SEO_DEFAULT */.C,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Exercises_Exercises, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var ejercicios = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,2552,9842,120,9746,2190,9774,2888,179], function() { return __webpack_exec__(54234); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);